export interface SupportTicket {
    issue_id: number | null;
    email:string;
    user_id:number | null;
    username:string;
    issue_status: string;
    org_id: number | null;
    issue_comments: string;
    issue_category: string;
    issue_description: string;
    attachments: File | null;
    attachments2: File | null;
    attachments3: File | null;
    attachments4: File | null;
    attachments5: File | null;
    attachments6: File | null;
  }

  export interface SupportTicketTable {
    issue_id: number | null;
    org_id:number | null;
    user_id:number | null;
    issue_status:string;
    created_date:string;
    resolved_date:string;
    issue_comments: string;
    issue_category: string;
    issue_description: string;
    attachments: File | null;
    attachments2: File | null;
    attachments3: File | null;
    attachments4: File | null;
    attachments5: File | null;
    attachments6: File | null;
  }
  
  interface Field {
    title: string;
    name: keyof SupportTicket;
    type: string;
    width: number;
    height?: number;
    isRequired: boolean;
    options?: string[];
  }
  
  export const SupportTicketFields: Field[] = [
    {
      title: "Category",
      name: "issue_category",
      type: "dropDown",
      width: 450,
      height: 70,
      isRequired: false,
      options: ["Issue", "Feedback"],
    },
    {
      title: "Attachments",
      name: "attachments",
      type: "dropZone",
      width: 450,
      isRequired: false,
      height: 70,
      options: [],
    },
    {
      title: "Comments",
      name: "issue_comments",
      type: "textArea",
      width: 450,
      height: 5,
      isRequired: false,
    },
    {
      title: "Description",
      name: "issue_description",
      type: "textArea",
      width: 450,
      height: 5,
      isRequired: false,
    },
    
  ];

  export const SupportTicketFieldsforpopup: Field[] = [
    {
      title: "Category",
      name: "issue_category",
      type: "dropDown",
      width: 100,
      height: 70,
      isRequired: false,
      options: ["Issue", "Feedback"],
    },
    {
      title: "Attachments",
      name: "attachments",
      type: "dropZone",
      width: 100,
      isRequired: false,
      height: 70,
      options: [],
    },
    {
      title: "Description",
      name: "issue_description",
      type: "textArea",
      width: 100,
      height: 5,
      isRequired: false,
    },
    {
      title: "Comments",
      name: "issue_comments",
      type: "textArea",
      width: 100,
      height: 5,
      isRequired: false,
    },
  ];
  
  